export default "__VITE_ASSET__D87Mkbt0__"